import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

// write state objects out to url, making it the source of truth
export const useUrlState = (
  namespace = "q",
  defaultValue?: string,
  replace?: boolean
): [string, (newVal: string) => void] => {
  // set initial state
  const defaultValueObject = useMemo(() => {
    /**
     * using any since there is probably
     * no way to tell all the possible
     * params for a Url
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    const o: any = {};
    o[namespace] = defaultValue ?? "";
    return o;
  }, [namespace, defaultValue]);

  const [searchParams, setSearchParams] = useSearchParams(defaultValueObject);

  //wrap the setter to remove empty query strings like q=""
  const setter = useCallback(
    (val: string) => {
      setSearchParams(
        (prev) => {
          // Important: clone instead of mutating `prev` in-place.
          // React Router may not navigate if the same URLSearchParams instance is returned.
          const next = new URLSearchParams(prev);

          if (!val) {
            // remove empty query strings from url
            next.delete(namespace);
          } else {
            next.set(namespace, val);
          }
          return next;
        },
        {
          replace: replace ?? false
        }
      );
    },
    [namespace, replace, setSearchParams]
  );
  const currentVal = searchParams.get(namespace) || "";
  return [currentVal, setter];
};
